<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <div class="d-sm-down-none">
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-black poppin-font text-48px">
                                    Take Your Video
                                </h1>
                                <p class="custom-16px-400 text-center ml-4">
                                    Get to know the talented individuals driving our company forward.
                                </p>
    
                                <br /><br /><br />
                                <CContainer>
                                    <CRow>
                                        <CCol sm="4">
                                            <CCard class="bg-white b-20 p-20" style="border:none">
                                                <img src="../assets/img/iconcamera.png" style="width:30px" class="m-4" />
                                                <h3 class="custom-24px-500 text-left ml-4">
                                                    Upload
                                                </h3>
                                                <p class="custom-16px-400 text-left ml-4">
                                                    Self-recording to answer instant questions on the Interviewrr portal and get expert feedback through the email/portal.
                                                </p>
                                            </CCard>
                                        </CCol>
                                        <CCol sm="4">
                                            <CCard class="bg-white b-20 p-20" style="border:none">
                                                <img src="../assets/img/iconai.png" style="width:30px" class="m-4" />
                                                <h3 class="custom-24px-500 text-left ml-4">
                                                    AI Review
                                                </h3>
                                                <p class="custom-16px-400 text-left ml-4">
                                                    Our AI-powered platform offers top-notch feedback,<br /> along with exclusive insights<br /> from industry experts.
                                                </p>
                                            </CCard>
                                        </CCol>
                                        <CCol sm="4">
                                            <CCard class="bg-white b-20 p-20" style="border:none">
                                                <img src="../assets/img/iconrefine.png" style="width:30px" class="m-4" />
                                                <h3 class="custom-24px-500 text-left ml-4">
                                                    Refinement
                                                </h3>
                                                <p class="custom-16px-400 text-left ml-4">
                                                    Tailored feedback to enhance user resume <br />and increase their chances <br /> of landing a job.
                                                </p>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </div>
                        </div>
                        <br />
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12">
            <CContainer>
                <CRow>
                    <div v-if="this.Error == true" class="ml-4 mr-4 mt-4">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                                                </CAlert>
                                            </div>

                                            <CCol sm="12" class="mt-3 p-0">
                        <CContainer>
                            <div>
                                <CCard class="custom-border-EAECF0">
                                    <CRow>
                                    <CCol sm="11">
                                        <h3 class="custom-30px-600 text-left font-inter">Upload Documents</h3>
                                        <p class="custom-16px-400 font-color-98A2B3 text-left">
                                        Upload your resume, references, or other documents to enhance your interview. (if required)
                                        </p>
                                    </CCol>
                                    <CCol sm="1" class="text-right">
                                        <img 
                                        :src="showNotes ? require('../assets/img/Minus-1.png') : require('../assets/img/Plus-1.png')" 
                                        width="40px" 
                                        class="mt-3 cursor-pointer" 
                                        @click="toggleNotes"
                                        />
                                    </CCol>
                                    </CRow>

                                    <!-- Notes Section -->
                                    <CRow v-if="showNotes">
                                        <CCol sm="12">
                                        <div class="p-3">
                                            <CCard>
                                            <div class="text-center file-upload-area" @dragover.prevent @drop="handleDrop" @click="triggerFileInput">
                                                <input type="file" ref="fileInput" multiple @change="handleFileSelect" style="display: none" />
                                                <br /><br /><br />
                                                <img src="../assets/img/uploadFile.png" width="50px" />
                                                <h3 class="custom-18px-500 text-center mt-3" style="color:#6941C6">
                                                Drag and drop your PDF file here, or click to select a file from your device.
                                                </h3>
                                                <h3 class="text-center custom-16px-400 font-color-696969">Maximum file size: 10 MB</h3>
                                                <br /><br /><br />
                                            </div>
                                            </CCard>

                                            <div v-if="document.length > 0 || uploadedFiles.length > 0" class="mt-4">
                                                <h3 class="custom-20px-600">Uploaded Files:</h3>
                                                <ul class="file-list">
                                                    <!-- Show uploading files with progress -->
                                                    <li v-for="file in uploadedFiles" :key="'uploading-' + file.name">
                                                    <div class="file-info">
                                                        <img src="../assets/img/iconfile.png" width="40px" class="file-icon" />
                                                        <span class="file-name ml-3">{{ file.name }}</span>
                                                    </div>

                                                    <!-- Progress Bar (only for files being uploaded) -->
                                                    <div v-if="uploadProgressBar[file.name] !== undefined" class="progress-bar-container">
                                                        <div class="progress-bar" :style="{ width: uploadProgressBar[file.name] + '%' }"></div>
                                                        <span class="progress-text">{{ uploadProgressBar[file.name] }}%</span>
                                                    </div>
                                                    </li>

                                                    <!-- Show completed files after upload (from API response) -->
                                                    <li v-for="file in document" :key="'document-' + file.Id">
                                                    <div class="file-info">
                                                        <img src="../assets/img/iconfile.png" width="40px" class="file-icon" />
                                                        <span class="file-name ml-3">{{ file.FileName }}</span>
                                                    </div>
                                                    <img src="../assets/img/delete.png" width="40px" class="delete-icon" @click="removeFile(file.FileId)" />
                                                    </li>
                                                </ul>
                                            </div>

                                            <!-- Notes Section -->
                                            <h3 class="custom-20px-600">Notes:</h3>
                                            <p class="custom-16px-400 font-color-98A2B3">
                                            1. You are encouraged to upload supporting documents, including your resume, reference letters, certificates, and any other relevant materials that can showcase your qualifications and enhance the interview process. Providing these documents allows us to gain a more comprehensive understanding of your skills, experiences, and achievements, giving you the best chance to stand out during the evaluation. 
                                            </p>
                                            <p class="custom-16px-400 font-color-98A2B3">
                                            2. If you are applying for financial services, such as a bank loan or similar products, it is important to ensure that you upload all the required documents to support your application. These may include, but are not limited to, your credit card records, recent bank statements, and other financial reports that demonstrate your creditworthiness and financial stability. Submitting complete and accurate documentation will help expedite the review process and increase the likelihood of a successful application. (If Required)
                                            </p>
                                        </div>
                                        </CCol>
                                    </CRow>
                                </CCard>
                            </div>
                        </CContainer>
                    </CCol>

                    <CCol sm="12">
                        <h3 class="custom-30px-600 mt-4">Interview Question</h3>
                    </CCol>
                    <CCol sm="6">
                        <label class="custom-20px-500" v-if="showInstruction">{{ instructionText }}</label>
                        <label class="custom-20px-500" v-if="showQuestion === true">{{ questions.index }} .{{ questions.question }}</label
                                  >
                                  <label class="custom-20px-500" v-if="showQuestion2 === true"
                                    >{{ question.index }} .{{ question.question }}</label
                                  >
                                  </CCol>
                                  <CCol sm="6">
                                    <div class="text-right">
                                        <CButton
      class="custom-border-purple-white font-color-928AFD mr-2"
      v-if="showQuestion === true"
      @click="OpenPopup()"
    >
      <span class="ml-2 mr-2">Practice Your Interview</span>
    </CButton>
                                      <span
                                        class="custom-border-purple p-2"
                                        style="width:120px"
                                        @click="GoToNextQuestion(index, questions.sessionId)"
                                        :class="{ disabled: isNextButtonDisabled }"
                                        v-if="index < 7"><span class="ml-5 mr-5">Next</span>
                                        </span>
                                        <span
                                        v-else
                                        class="custom-border-purple p-2"
                                        style="width:120px"
                                        @click="OpenHomepage()"
                                        ><span class="ml-5 mr-5">Close</span></span
                                      >
                                    </div>
                                  </CCol>
                                  <CCol sm="12">
                                    <div class="video-container">
                                      <video
                                        :class="{ hideAfterStop: toggleVideo }"
                                        ref="videoElement"
                                        autoplay
                                      ></video>
                                      <div class="timer" v-if="isRecording">
      {{ formatTime(elapsedTime) }} / 
      {{ index === 1 ? questions.maxTimeLimit : question.maxTimeLimit }}
    </div>
                                      <div class="button-container">
                                        <CRow>
                                          <CCol sm="4">
                                          
                                            <button
                                              class="record-button"
                                              @click="toggleRecording(index)"
                                              :class="{ recording: isRecording }"
                                            >
                                              <i v-if="!isRecording" class="fas fa-play"></i>
                                              <i v-else class="fas fa-stop"></i>
                                            </button>
                                          </CCol>
                                        </CRow>
                                      </div>
                                      <!-- <video ref="videoResult" controls style="display: none;"></video> -->
                                    </div>
                                  </CCol>
                                  <CCol sm="12">
                                    <h3 class="custom-18px-600 text-center font-color-171717 mt-3" v-if="!isRecording && hideNextButton">Click <strong>Red Button</strong> to Start</h3>
<h3 class="custom-18px-600 font-color-171717 text-center mt-3" v-if="!isRecording && !hideNextButton && index < 7">Click <strong>Next Button</strong> to go to the next question</h3>
<h3 class="custom-18px-600 font-color-171717 text-center mt-3" v-if="isRecording">You can start to give feedback/survey. Click <strong>Green Button</strong> to stop</h3>

                                  </CCol>
                                  <CCol sm="12">
                                          <CRow>
                                              <CCol v-if="uploadProgress > 0" sm="12">
                                                  <p class="custom-14px-500 mt-3 font-color-171717">Upload Process – {{ uploadProgress }}%</p>
                                                  <p class="custom-14px-500 font-color-171717">After uploading the video you can click next to continue the interview</p>
                                                  <progress v-if="uploadProgress > 0" style="width: 100%" :value="uploadProgress"></progress>
                                                  <!-- Indikator progres -->
                                              </CCol>
                                              <CCol sm="12">
                                                  <h4 class="custom-20px-700 mt-4">
                                                      Tips For Answer
                                                  </h4>
                                                  <p class="custom-18px-500 font-color-171717">
                                                      Please respond to the question based on your understanding of the subject, recording yourself using your computer's camera within the allocated time. Ensure you have good lighting, minimal background noise, and aim for a high-quality recording to enhance
                                                      your presentation.
                                                  </p>
                                              </CCol>
                                          </CRow>
                                      </CCol>
                                  </CRow>
                              </CContainer>
                          </CCol>
            
            
                          <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
                              <br />
                              <br />
                              <br />
                              <CCol sm="12" lg="12">
                                  <div class="text-center p-2">
                                      <CCol sm="12" style="width: 80%;margin: auto;">
                                          <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                                              <br />
                                              <br />
                                              <br />
                                              <br />
                                              <h1 class="custom-header-join text-white poppin-font text-48px mt-5">
                                                  Subscribe Now for Free
                                              </h1>
                                              <br />
                                              <label class="custom-header-join-sub text-white">
                                        Sign up now for free and take the first step toward landing your
                                        dream job!
                                      </label>
                        <br />
                        <br />
                        <br />
                        <br />
                        <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
    </div>
    </CCol>
    </div>
    <br /><br /><br />
    </CCol>
    </CCol>
    </div>
    
    <div class="d-md-none d-lg-none">
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <br /> <br />
            <CCard class="p-2 b-20" style="margin-top:20%;margin-bottom:20%" v-if="showMain">
                <div class="text-center">
                    <img src="../assets/img/Logo(1).png" style="max-width:100px" class="text-center"/>
                </div>
               
                <div v-if="showQuestion === true" class="text-center"> 
                    <!-- <label class="custom-12px-400 text-center font-inter text-inter">Q{{ questions.index }} :</label
                                  > -->
                                  <br />
                                <label class="custom-24px-700 font-inter text-center font-color-6C6C6C">Welcome to <br />interviewrr.ai</label>
                </div>
    
               
                                  <CCol sm="12" class="text-center mt-3">
                                    <CButton
                                        class="custom-border-purple text-white" style="max-width:200px" @click="ShowQuestionSurvey()">Start
                                  </CButton>
                                  </CCol>
                                 
                                  
                   </CCard>
                   <br /> <br />
            
                <CCol sm="12" v-if="showStartSurvey">

                    <CCard class="p-2 b-20">
              
               
                <label class="custom-20px-500 text-center" v-if="showInstruction">{{ instructionText }}</label>
                <div v-if="showQuestion === true" class="text-center"> 
                    <!-- <label class="custom-12px-400 text-center font-inter text-inter">Question{{ questions.index }}</label
                                  > -->
                                  <br />
                                <label class="custom-24px-700 font-inter text-center font-color-6C6C6C">Q{{ questions.index }}:{{ questions.question }}</label>
                </div>
    
                <label class="custom-20px-500 text-center" v-if="showQuestion2 === true">
                    <!-- <label class="custom-24px-700 text-center font-inter text-inter">Question</label
                                  > -->
                                  <br />
                                <label class="custom-24px-700 font-inter text-center font-color-6C6C6C">Q{{ question.index }}:{{ question.question }}</label>
                 </label>
                                 
                                  
                   </CCard>
                   <CContainer class="p-0">
                        <CRow class="p-0">
                            <CCol sm="12">
                            </CCol>
                            <CCol sm="9">
             
                                  </CCol>
                                  <CCol sm="3">
                                    <!-- <div class="text-right">
                                        
                                      <span
                                        class="custom-border-purple p-2"
                                        style="width:120px"
                                        @click="GoToNextQuestion(index, questions.sessionId)"
                                        :class="{ disabled: isNextButtonDisabled }"
                                        v-if="index < 7"><span class="ml-5 mr-5">Next</span>
                                        </span>
                                        <span
                                        v-else
                                        class="custom-border-purple p-2"
                                        style="width:120px"
                                        @click="OpenProfile()"
                                        ><span class="ml-5 mr-5">View All</span></span
                                      >
                                    </div> -->
                                  </CCol>
                                  <CCol sm="12">
                                    <CCard class="p-2 b-20">
                                    <div class="video-container">
                                      <video
                                        :class="{ hideAfterStop: toggleVideo }"
                                        ref="videoElement"
                                        autoplay
                                        style="height:300px"
                                      ></video>
                                      <div class="timer" v-if="isRecording">{{ formatTime(elapsedTime) }} / 02:00</div>
                                      <div class="button-container">
                                        <CRow>
                                          <CCol sm="4">
                                          
                                            <button
                                              class="record-button"
                                              @click="toggleRecording(index)"
                                              :class="{ recording: isRecording }"
                                            >
                                              <i v-if="!isRecording" class="fas fa-play"></i>
                                              <i v-else class="fas fa-stop"></i>
                                            </button>
                                          </CCol>
                                        </CRow>
                                      </div>
                                      <!-- <video ref="videoResult" controls style="display: none;"></video> -->
                                    </div>
                                    </CCard>
                                    <CCol sm="12" class="text-center mt-3">
                                    <CButton
                                        class="badge-purple text-white p-2" style="width:100px;font-size:20px" @click="GoToNextQuestion(index, questions.sessionId)"
                                        :class="{ disabled: isNextButtonDisabled }"
                                        v-if="index < 7">Next
                                  </CButton>
                                  <CButton
                                        class="custom-border-purple text-white" style="max-width:200px" @click="OpenHomepage()"
                                       v-else>Close
                                  </CButton>
                                  <br /> <br /> <br />
                                  </CCol>
                                  </CCol>
                                 
                                  </CRow>
                    </CContainer>
                </CCol>
                <br /> <br />
            </CCol>
            
            
        
                </div>
    
    <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <img style="max-width: 100px" src="../assets/img/rightstar.png" />
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Thank you for completing <br /> the interview.</h3>
                <h3 class="custom-16px-400 text-center">
                    Your responses are being carefully reviewed, and we will notify you of the results within the next 2 days.
                </h3>
            </div>
    
            <CButton class="custom-border-purple text-white" @click="OpenFeedback()" block><span class="ml-2 mr-2">Feedback AI Interviewrr</span></CButton>
    
            <div class="text-center mt-3">
                <span class="text-center font-color-615FCD" @click="closePopup2()">Not Now</span>
            </div>
        </div>
    </div>
    
    <div v-if="PopupFeedback" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Rate Interview</h3>
                <h3 class="custom-16px-400 text-center">
                    Your responses are being carefully reviewed, and we will notify you of the results within one day.
                </h3>
                <h4 class="custom-16px-400 text-center mt-2">Rating</h4>
                <div id="star-container">
                    <img v-for="index in 5" :key="index" :src="getStarSrc(index)" @click="updateStars(index)" class="star" style="width:56px" :class="{ grey: index > rating, yellow: index <= rating }" />
                </div>
    
                <CTextarea v-model="comment" placeholder="enter your story about AI Interview" class="mt-3" />
            </div>
    
            <CButton class="custom-border-purple text-white" @click="SubmitFeedback" block><span class="ml-2 mr-2">Send Feedback AI Interviewrr</span></CButton>
    
        </div>
    </div>
    
    <div v-if="SuccessPopup" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <img style="max-width: 100px" src="../assets/img/success.png" />
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Success!</h3>
                <h3 class="custom-16px-400 text-center">
                    Your survey review is succesfully added
                </h3>
            </div>
    
            <CButton class="custom-border-purple text-white" @click="closeSuccessFeedback()" block><span class="ml-2 mr-2">Close</span></CButton>
    
    
        </div>
    </div>
    
    <div v-if="showConfirmationDialog" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <h3 class="custom-18px-700 text-center">
                    Would you like to record voice only or video with voice?
                </h3>
            </div>
            <div class="justify-content-between m-0 text-center">
                <CButton class="custom-border-purple text-white p-2 mr-2" @click="allowCamera"><img src="../assets/img/Video 3.png" style="max-width:20px"/><span class="ml-2 mr-2">Video</span></CButton>
                  <CButton class="badge-purple p-2" @click="denyCamera"><img src="../assets/img/Voice.png" style="max-width:20px"/><span class="ml-2 mr-2 font-color-928AFD">Voice only</span></CButton>

            </div>

          
    
            
           
        </div>
    </div>

    <div v-if="showPopup" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <h3 class="custom-24px-500 custom-24px-600 font-color-171717 text-left">Title : Practice Video Interview Process
</h3>
                <br />
                <h3 class="custom-14px-400 text-left font-color-171717">
                    Welcome to the Interviewrr.ai platform! Here, you can practice your video interview skills. Feel free to take as many attempts as needed to get comfortable with the process. Follow the instructions at top of each video step-by-step, and take your time to familiarize yourself with the system before your actual interview.
</h3>
<br />
                <CButton class="custom-border-purple text-white mt-2" @click="GoToTrial" block><span class="ml-2 mr-2">Start Trial Interview</span></CButton>
            </div>
        </div>
    </div>

    
    
    
    
    
    
    
    <Footerlayout class="d-sm-down-none"></Footerlayout>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/HeaderQR.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,
            mediaRecorder: null,
            recordedChunks: [],
            isRecording: false,
            toggleVideo: false,
            uploadProgress: 0,
            questions: {},
            index: 1,

            question: {},

            showQuestion: true,
            showQuestion2: false,
            isNextButtonDisabled: true,

            elapsedTime: 0,
            timerInterval: null,
            isLanguagePopupVisible2: false,
            PopupFeedback: false,
            rating: 0,
            comment: '',
            SuccessPopup: false,
            instructionText: "You will see the question once you click the record button.",
            showInstruction: "",
            checking: {},
            showConfirmationDialog: false,
            cameraAccessDenied: false,
            Error: false,
            user: {},
            Message: "",
            showStartSurvey: false,
            showMain: true,

            showPopup: false,


            hideNextButton: true,

            showNotes: false,

            uploadedFiles: [],
            document:[],
            uploadProgressBar: {},  

        };
    },
    async created() {
        AOS.init();
    },
    async mounted() {
     

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                this.getFirstQuestion();
                // await this.getListQuestion(this.index);
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
       
        toggle() {
            this.isActive = !this.isActive;
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        timeStringToSeconds(timeString) {
    if (typeof timeString !== 'string') {
        console.error("Expected a string for time format, but received:", timeString);
        return 0; // Return a default value or handle it as needed
    }

    const timeParts = timeString.split(":").map(Number);

    if (timeParts.length === 3) {
        // If time string is in "hh:mm:ss" format
        const [hours, minutes, seconds] = timeParts;
        return (hours * 3600) + (minutes * 60) + seconds;
    } else if (timeParts.length === 2) {
        // If time string is in "mm:ss" format
        const [minutes, seconds] = timeParts;
        return (minutes * 60) + seconds;
    } else {
        // Handle unexpected formats
        console.error("Invalid time format:", timeString);
        return 0;
    }
},

        async startRecording(index) {
            try {
                await this.GetCheckingUploadVideo(index, this.questions.sessionId);

                if (this.checking === false) {
                    this.showInstruction = false;
//                     console.log("Index:", index);
// console.log("Questions Max Time Limit:", this.questions.maxTimeLimit);
// console.log("Question Max Time Limit:", this.question.maxTimeLimit);
//                     let maxTimeLimitStr = index === 1 ? this.questions.maxTimeLimit : this.question.maxTimeLimit;

// if (!maxTimeLimitStr) {
//     console.warn("Max Time Limit is undefined for index", index, ". Using default value.");
//    // maxTimeLimitStr = "00:02:00"; // Default value
// }

// const maxTimeLimitInSeconds = this.timeStringToSeconds(maxTimeLimitStr);
// console.log("Max Time Limit in Seconds:", maxTimeLimitInSeconds);


if (index !== 1) {
                await this.getListQuestion(index, this.questions.sessionId); // Ensure this gets question data for the current index
            }

            // Safely get the maxTimeLimit based on index
            let maxTimeLimitStr = index === 1 ? this.questions.maxTimeLimit : this.question?.maxTimeLimit;
            const maxTimeLimitInSeconds = this.timeStringToSeconds(maxTimeLimitStr);
            console.log("Max Time Limit in Seconds:", maxTimeLimitInSeconds);


                    // Check if camera access was denied before
                    if (this.cameraAccessDenied) {
                        return this.startRecordingAudio(index); // Proceed with audio recording only
                    }

                    // Request video and audio stream
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            width: { ideal: 1280 },
                            height: { ideal: 720 },
                            frameRate: { ideal: 30 },
                        },
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });

                    // Set up the video element and media recorder
                    this.$refs.videoElement.srcObject = stream;
                    this.$refs.videoElement.muted = true;
                    this.mediaRecorder = new MediaRecorder(stream);

                    this.mediaRecorder.ondataavailable = (event) => {
                        if (event.data.size > 0) {
                            this.recordedChunks.push(event.data);
                        }
                    };

                    this.mediaRecorder.onstop = () => {
                        this.handleRecordingStop(index);
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.isNextButtonDisabled = true;
                    this.elapsedTime = 0;
                    this.timerInterval = setInterval(() => {
                        this.elapsedTime++;
                        // if (this.elapsedTime >= 120) {
                        //     this.stopRecording();
                        // }
                        if (this.elapsedTime >= maxTimeLimitInSeconds) {
                    this.stopRecording();
                }
                    }, 1000);

                    // Display the question when recording starts
                    if (index === 1) {
                        this.showQuestion = true;
                        this.showQuestion2 = false;
                    } else {
                        this.showQuestion2 = true;
                        this.showQuestion = false;
                        this.getListQuestion(index, this.questions.sessionId);
                    }

                } else {
                    alert("Error. You already submitted this question. Please proceed to the next question by clicking the Next button.");
                }

            } catch (error) {
                console.error("Error accessing media devices: ", error);
                alert("Error accessing media devices. No device found.");
            }
        },

        async startRecordingAudio(index) {
            try {
                await this.GetCheckingUploadVideo(index, this.questions.sessionId);

                if (this.checking === false) {
                    this.showInstruction = false;

//                     console.log("Index:", index);
// console.log("Questions Max Time Limit:", this.questions.maxTimeLimit);
// console.log("Question Max Time Limit:", this.question.maxTimeLimit);
//                     let maxTimeLimitStr = index === 1 ? this.questions.maxTimeLimit : this.question.maxTimeLimit;

// if (!maxTimeLimitStr) {
//     console.warn("Max Time Limit is undefined for index", index, ". Using default value.");
//    maxTimeLimitStr = "00:02:00"; // Default value
// }

// const maxTimeLimitInSeconds = this.timeStringToSeconds(maxTimeLimitStr);
// console.log("Max Time Limit in Seconds:", maxTimeLimitInSeconds);

            if (index !== 1) {
                await this.getListQuestion(index, this.questions.sessionId); // Ensure this gets question data for the current index
            }

            // Safely get the maxTimeLimit based on index
            let maxTimeLimitStr = index === 1 ? this.questions.maxTimeLimit : this.question?.maxTimeLimit;
            const maxTimeLimitInSeconds = this.timeStringToSeconds(maxTimeLimitStr);
            console.log("Max Time Limit in Seconds:", maxTimeLimitInSeconds);


                    // Request audio-only stream
                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });

                    // Set up the media recorder for audio
                    this.mediaRecorder = new MediaRecorder(stream);

                    this.mediaRecorder.ondataavailable = (event) => {
                        if (event.data.size > 0) {
                            this.recordedChunks.push(event.data);
                        }
                    };

                    this.mediaRecorder.onstop = () => {
                        this.handleRecordingStop(index);
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.isNextButtonDisabled = true;
                    this.elapsedTime = 0;
                    this.timerInterval = setInterval(() => {
                        this.elapsedTime++;
                        // if (this.elapsedTime >= 120) {
                        //     this.stopRecording();
                        // }
                        if (this.elapsedTime >= maxTimeLimitInSeconds) {
                    this.stopRecording();
                }
                    }, 1000);

                    // Display the question when recording starts
                    if (index === 1) {
                        this.showQuestion = true;
                        this.showQuestion2 = false;
                    } else {
                        this.showQuestion2 = true;
                        this.showQuestion = false;
                        this.getListQuestion(index, this.questions.sessionId);
                    }

                } else {
                    alert("Error. You already submitted this question. Please proceed to the next question by clicking the Next button.");
                }

            } catch (error) {
                console.error("Error accessing media devices: ", error);
                alert("Error accessing media devices. No device found.");
            }
        },

        allowCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = true;
            this.cameraAccessDenied = false; // Reset the camera access denial status

            // Proceed with the existing logic to start recording
            this.startRecording(1);
        },

        denyCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = false;
            this.cameraAccessDenied = true; // Mark camera access as denied
            //alert("Camera access denied.");
            this.startRecordingAudio(1);
        },

        stopRecording() {
//             if (this.elapsedTime < 60) {
//     alert("You must record for at least 1 minute.");
//     return;
//   }
            if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
                this.mediaRecorder.stop();
                if (this.$refs.videoElement.srcObject) {
                    const tracks = this.$refs.videoElement.srcObject.getTracks();
                    tracks.forEach((track) => track.stop());
                }
                this.$refs.videoElement.srcObject = null;
                this.recordedChunks = [];
                this.uploadProgress = 0;
                this.isRecording = false;
                clearInterval(this.timerInterval); // Stop the timer
                this.timerInterval = null;
                clearTimeout(this.stopRecordingTimeout);
              
            }
            this.hideNextButton = false;  // Ensure button is not hidden
        },

        async handleRecordingStop(index) {
            const recordedBlob = new Blob(this.recordedChunks, {
                type: this.allowCameraAccess ? "video/webm" : "audio/webm",
            });

            this.recordedChunks = [];

            const formData = new FormData();
            formData.append("file", recordedBlob, this.allowCameraAccess ? "rekaman.webm" : "rekaman_audio.webm");
            formData.append("sessionId", this.questions.sessionId);
            formData.append("indexNo", index);
            formData.append("userId", this.user.id);

            this.$API.post(this.$uploadFile, formData, {
                onUploadProgress: (progressEvent) => {
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                },
            }).then((response) => {
                if (response.status === 200) {
                    this.videoId = response.data.videoId;
                   // this.InsertVideoText(this.videoId);
                    this.retryOperation(() => this.InsertVideoText(this.videoId));
                    console.log("Successfully uploaded.");
                } else {
                    console.error("Failed to upload.");
                }
            }).catch((error) => {
                console.error("Error:", error);
            });

            this.isNextButtonDisabled = false;
        },
        async GetCheckingUploadVideo(index, sessionId) {
            try {
                const response = await this.$API.get(this.$CheckVideoSessionIndex + "?sessionId=" + sessionId + "&indexNo=" + index);
                if (response.status === 200) {
                    this.checking = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async retryOperation(operation, retries = 7, delay = 1000) {
    let attempts = 0;
    while (attempts < retries) {
        try {
            return await operation();
        } catch (error) {
            attempts++;
            console.error(`Attempt ${attempts} failed. Error: ${error.message}`);
            if (attempts < retries) {
                await new Promise((resolve) => setTimeout(resolve, delay));
            } else {
                console.error("All retry attempts failed.");
                throw error;
            }
        }
    }
},
        InsertVideoText(videoId) {

            this.$API
                .get(this.$ExtractAudioText + "/" + videoId)
                .then((response) => {

                    if (response.status == 200) {
                        console.log("success convert");
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                    this.InsertVideoText(videoId);
                });
        },


        toggleRecording(index) {
            if (this.isRecording) {
                this.hideNextButton = false;
                this.stopRecording();
            } else {
                if (index === 1) {
                    // For the first question, show confirmation dialog
                    this.showConfirmationDialog = true;
                } else {
                    this.hideNextButton = true;
                    // For subsequent questions, check if camera access is allowed
                    if (this.allowCameraAccess) {
                        this.startRecording(index);
                        this.hideNextButton = false;
                    } else {
                        this.hideNextButton = false;
                        this.startRecordingAudio(index);
                    }
                }
            }
        },
        async GoToNextQuestion(index, sessionId) {
            this.hideNextButton = true;
            this.isNextButtonDisabled = true;
            this.showInstruction = true;
            this.showQuestion2 = false;
            this.showQuestion = false;
            this.index++;
            //this.getListQuestion(index, sessionId);

        },
        async getFirstQuestion() {
    try {
        const response = await this.$API.get(this.$GetFirstQuestionByCode + "?code=" + this.$route.query.code, { withCredentials: true });
        
        if (response.status === 200) {
            this.questions = response.data;
        } else {
            this.Loading = false;
            this.Error = true;
            this.Message = response.data || 'An error occurred';
        }
    } catch (error) {
        this.Loading = false;
        this.Error = true;
        this.Message = error.response?.data || 'An error occurred';
    }
},



        async getListQuestion(index, sessionId) {
            this.showQuestion = false;
            if (index > 6) {
                this.stopRecording();
                this.SubmitEmail();
                this.SuccessPopup = true;
                this.In
            } else {
                try {
                    const codeCompany = this.$route.query.code;

                    if (codeCompany != null) {
                        const response = await this.$API.get(
                            `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index}&code=${codeCompany}`, {
                                withCredentials: true,
                            }
                        );
                        if (response.status === 200) {
                            if (response.data === 'Skip') {
                                const response = await this.$API.get(
                                    `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index+1}&code=${codeCompany}`, {
                                        withCredentials: true,
                                    });
                                this.question = response.data;
                                this.showQuestion = false;

                            } else {
                                this.question = response.data;
                                this.showQuestion = false;

                            }



                        } else {}

                    } else {
                        const response = await this.$API.get(
                            `${this.$GetNextQuestion}/${sessionId}/${index}`, {
                                withCredentials: true,
                            }
                        );
                        if (response.status === 200) {
                            this.question = response.data;
                            this.showQuestion = false;
                        } else {}

                    }
                } catch (error) {}
            }
        },

        SubmitData() {

            const field = this.$route.query.field;
            const expertise = this.$route.query.expertise;

            const formData = new FormData();

            formData.append("email", this.user.email);
            formData.append("experties", expertise);
            formData.append("field", field);

            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {
                                this.isLanguagePopupVisible2 = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenHomepage() {
           // this.SignOut();
           this.SubmitEmail();
           this.InsertReport();
            this.SuccessPopup = true;
          
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
        closePopup2() {
            this.isLanguagePopupVisible2 = false;
        },
        OpenFeedback() {
            this.isLanguagePopupVisible2 = false;
            this.PopupFeedback = true;
        },
        updateStars(index) {
            this.rating = index;
        },
        getStarSrc(index) {
            return index <= this.rating ? require('../assets/img/star-yellow.png') : require('../assets/img/star-grey.png');
        },
        SubmitFeedback() {
            this.PopupFeedback = false;
            const formData = new FormData();
            formData.append("comment", this.comment);
            formData.append("rate", this.rating);

            this.$API
                .post(this.$SubmitFeedbacks, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.SuccessPopup = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccessFeedback() {
            this.SuccessPopup = false;
            this.$router.push("/");
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        ShowQuestionSurvey()
        {
            this.showMain = false;
            this.showStartSurvey= true;
        },
        OpenPopup() {
            this.showPopup = true; // Keep the popup open on click
        },
        GoToTrial()
        {
            this.showPopup = false;
            window.open("https://www.interviewrr.ai/directinterview?code=wbxUkS");
        },
        SubmitEmail() {
            this.PopupFeedback = false;
            const formData = new FormData();
            formData.append("sessionId", this.questions.sessionId);

            this.$API
                .post(this.$SendEmailAI, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                            
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async InsertReport() {
  
        try {
            const response = await this.$API.get(`${this.$GenerateReport}?session_id=`+ this.questions.sessionId);
            if (response.status === 200) {
                
                
            } else {
                
            }
        } catch (error) {
            
        }
        },
        toggleNotes() {
            this.showNotes = !this.showNotes;
        },
     
  
        triggerFileInput() {
            this.$refs.fileInput.click(); // Opens file picker
        },
        handleFileSelect(event) {
            const files = Array.from(event.target.files);
            this.processFiles(files);
        },
        handleDrop(event) {
            event.preventDefault();
            const files = Array.from(event.dataTransfer.files);
            this.processFiles(files);
        },
        processFiles(files) {
            files.forEach((file) => {
            if (file.size <= 10 * 1024 * 1024) { // 10MB Limit
            // Add the file to uploadedFiles only once, before uploading
            if (!this.uploadedFiles.some(f => f.name === file.name)) {
                this.uploadedFiles.push({ name: file.name, uploading: true });
                this.uploadFile(file); // Start the upload for this file
            }
            } else {
            alert("File size exceeds 10MB!");
            }
            });
        },
        async uploadFile(file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("userId", this.user.id);
            formData.append("sessionId", this.questions.sessionId);

            try {
                const response = await this.$API.post(this.$uploadDocument, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    this.$set(this.uploadProgressBar, file.name, percentCompleted);
                },
                });

                if (response.status === 200) {
                console.log("File uploaded successfully:", file.name);

                // Remove the file from uploading state
                this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== file.name);

                // Refresh the document list from API after the upload completes
                await this.getListDoc(this.questions.sessionId);
                } else {
                console.error("Failed to upload file:", file.name);
                }
            } catch (error) {
                console.error("Upload error:", error);
                // Handle error gracefully, remove file from progress
                this.$delete(this.uploadProgressBar, file.name);
                this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== file.name);
            }
        },
        removeFile: function(id) {
                const formData = new FormData();

                formData.append("fileId", id);

                return this.$API
                    .post(this.$DeleteDocument, formData, {
                        withCredentials: true,
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            this.getListDoc(this.questions.sessionId);
                        } else {
                            this.Busy = false;
                        }
                    })
                    .catch((error) => {
                        this.Busy = false;
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
        },
        async getListDoc(sessionId) {
            try {
                const response = await this.$API.get(this.$GetDocDetails + "?sessionId=" + sessionId, {
                withCredentials: true,
                });

                if (response.status === 200) {
                this.uploadedFiles = []; // Clear temporary files from the upload process
                this.document = response.data; // Replace with the files fetched from the API
                }
            } catch (error) {
                console.error("Error fetching document list:", error);
            }
        }
        
    },
};
</script>

<style scoped>
@import url("https://fonts.cdnfonts.com/css/general-sans");
body {
    top: 0 !important;
    font-family: "General Sans", sans-serif;
}

.video-container {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 21px;
    max-width: 100%;
}

.button-container {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.record-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f44336;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.record-button:hover {
    background-color: #d32f2f;
}

.record-button.recording {
    background-color: #8bc34a;
}

.record-button i {
    margin-top: 8px;
}

.hideAfterStop {
    display: none;
}

video {
    border-radius: 21px;
    width: 100%;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.timer {
    position: absolute;
    top: 24px;
    right: 0px;
    -webkit-transform: translateX(-20%);
    transform: translateX(-20%);
    font-size: 20px;
    color: white;
    background: #F02222;
    padding: 5px 10px;
    border-radius: 17px;
}
@media (max-width: 768px) {
.popup-all1 {
        width: 90%;
        max-width: 500px;
        padding: 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 20px;
        z-index: 1000;
        margin: 0 auto;
        margin-top: 50%;
    }
}

/* Container for the progress bar */
.progress-bar-container {
  width: 100%;
  background-color: #ddd;
  border-radius: 4px;
  height: 10px;
  margin-top: 5px;
  position: relative;
}

/* Style for the actual progress bar */
.progress-bar {
  height: 100%;
  background-color: #7F56D9;
  border-radius: 4px;
  transition: width 0.2s ease-in-out;
}

/* Style for the text inside the progress bar */
.progress-text {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #fff;
  top: 50%;
  transform: translateY(-50%);
}
</style>
